import { Response } from '@angular/http';
import { HttpClient } from './http-client';
import { BehaviorSubject } from 'rxjs';

export abstract class BaseEntityService {
    IsInitialized: boolean = false;
    private isGetting: boolean = false;
    Options: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    constructor(public httpClient: HttpClient) { }
    abstract get apiRoute(): string;
    abstract responseItemToEntity(responseItem): any;

    loadOptions() {
        if (this.isGetting) return;
        this.isGetting = true;
        this.getAllElements().subscribe(response => {
            let arrayOptions = [];
            response.forEach(item => {
                let entity = this.responseItemToEntity(item);
                arrayOptions.push(entity);
            });
            this.Options.next(arrayOptions.sort((a,b)=>this.sortItems(a,b)));
            this.IsInitialized = true;
            this.isGetting = false;
        },
        err => {
            this.isGetting = false;
        });
    }

    getAllElements() {
        return this.httpClient.get(this.apiRoute)
            .map((response: Response) => {
                return response.json().ResponseData;
            });
    }

    sortItems(a, b) {
        return 0;
    }
}


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/baseentity-service.ts